import request from '../../../../api/request';
import { CourseHistory } from '../parts/academicHistory/academicHistorytabs/Curriculum/types/history';
import { CurriculumProgressBase } from '../parts/academicHistory/academicHistorytabs/Curriculum/types/progress';
import { ProgressCurrentPeriodResponse } from '../parts/academicHistory/academicHistorytabs/ProgressInCurrentPeriod/types';
import { TitulationData } from '../types';

const ACADEMIC_HISTORY = {
  GET_POSTULANT_ACADEMIC_HISTORY: (studentId: string | number) =>
    `teacher-portal/student-file/academic-history/${studentId}`,
  GET_ACADEMIC_HISTORY_PROGRESS: (studyPlanEnrollmentId: string | number) =>
    `teacher-portal/student-file/academic-history/students/${studyPlanEnrollmentId}`,
  GET_ACADEMIC_HISTORY_GRADES: (studyPlanEnrollmentId: string | number) =>
    `teacher-portal/student-file/academic-history/grades-history/${studyPlanEnrollmentId}`,
  GET_TITULATION_DATA: (studyPlanEnrollmentId: string | number) =>
    `teacher-portal/student-file/academic-history/titulation-data/${studyPlanEnrollmentId}`,
  GET_CURRICULUM_PROGRESS: (studyPlanEnrollmentId: string | number) =>
    `teacher-portal/student-file/academic-history/curriculum/${studyPlanEnrollmentId}`,
};

export const getAcademicHistoryGrades = (id: number | string) => {
  return request<CourseHistory>(
    ACADEMIC_HISTORY.GET_ACADEMIC_HISTORY_GRADES(id),
  );
};

export function getCurriculumProgress(studyPlanEnrollmentId: number | string) {
  const url = ACADEMIC_HISTORY.GET_CURRICULUM_PROGRESS(studyPlanEnrollmentId);
  return request<CurriculumProgressBase>(url);
}

export const getPostulantAcademicHistory = (studentId: number | string) => {
  return request(ACADEMIC_HISTORY.GET_POSTULANT_ACADEMIC_HISTORY(studentId));
};

export const getProgressInCurrentPeriod = (id: number | string) => {
  return request<ProgressCurrentPeriodResponse>(
    ACADEMIC_HISTORY.GET_ACADEMIC_HISTORY_PROGRESS(id),
  );
};

export const getTitulationData = (studyPlanEnrollmentId: number | string) => {
  return request<TitulationData>(
    ACADEMIC_HISTORY.GET_TITULATION_DATA(studyPlanEnrollmentId),
  );
};
